import { defineStore } from 'pinia';
import { ref } from 'vue';

type SchemaEditId = number | string;
type MapSchemaObject = Record<string, SchemaEditId>;

export const useSchemaEditStore = defineStore('schemaEdit', () => {
    const attributeId = ref<SchemaEditId | null>(null);

    const classId = ref<SchemaEditId | null>(null);
    const classInterfaceId = ref<SchemaEditId | null>(null);
    const interfaceId = ref<SchemaEditId | null>(null);

    const mapSchemaId = ref<SchemaEditId | null>(null);
    const mapSchemaObject = ref<MapSchemaObject | null>(null);

    const relationId = ref<SchemaEditId | null>(null);

    const selectedSchema2 = ref<string | null>(null);

    function setAttributeId(value: SchemaEditId | null) {
        attributeId.value = value;
    }

    function setClassId(id: SchemaEditId | null) {
        classId.value = id;
    }

    function setClassInterfaceId(id: SchemaEditId | null) {
        classInterfaceId.value = id;
    }

    function setRelationId(id: SchemaEditId | null) {
        relationId.value = id;
    }

    function setInterfaceId(id: SchemaEditId | null) {
        interfaceId.value = id;
    }

    function setMapSchemaId(id: SchemaEditId | null) {
        mapSchemaId.value = id;
    }

    function setMapSchemaObject(object: MapSchemaObject | null) {
        mapSchemaObject.value = object;
    }

    function popAttributeId() {
        const value = attributeId.value;
        attributeId.value = null;
        return value;
    }

    function popClassId() {
        const value = classId.value;
        classId.value = null;
        return value;
    }

    function popClassInterfaceId() {
        const value = classInterfaceId.value;
        classInterfaceId.value = null;
        return value;
    }

    function popRelationId() {
        const value = relationId.value;
        relationId.value = null;
        return value;
    }

    function popInterfaceId() {
        const value = interfaceId.value;
        interfaceId.value = null;
        return value;
    }

    function popMapSchemaId() {
        const value = mapSchemaId.value;
        mapSchemaId.value = null;
        return value;
    }

    function popMapSchemaObject() {
        const object = mapSchemaObject.value;
        mapSchemaObject.value = null;
        return object;
    }

    return {
        attributeId,
        classId,
        classInterfaceId,
        interfaceId,
        mapSchemaId,
        mapSchemaObject,
        relationId,
        selectedSchema2,
        popAttributeId,
        popClassId,
        popClassInterfaceId,
        popInterfaceId,
        popMapSchemaId,
        popMapSchemaObject,
        popRelationId,
        setAttributeId,
        setClassId,
        setClassInterfaceId,
        setInterfaceId,
        setMapSchemaId,
        setMapSchemaObject,
        setRelationId
    };
});
